var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10L8.16795 0.280023C8.6718 -0.0933413 9.3282 -0.0933413 9.83205 0.280025L18 10H0Z",
    fill: "#4A5256"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTooltip);
export default __webpack_public_path__ + "static/media/questionTooltip.8be39e3e0602f134bffe73d5cde633ed.svg";
export { ForwardRef as ReactComponent };